import { bem } from "@react-md/utils";

export const block = bem("mmc-time-dropdown-picker");
